const moment = require('moment');

// 1-hour session types
const SessionTypes = {
  mock: {
    name: 'Mock Interview',
    AirtableService: 'Mock Interviews',
    value: 'mock',
    description: 'Practice interviewing and get feedback from your coach.',
  },
  career: {
    name: 'Career Coaching',
    AirtableService: 'Career Coaching',
    value: 'career',
    description: 'Navigate career goals, role transitions, promotions, and more.',
  },
  negotiation: {
    name: 'Negotiation Coaching',
    AirtableService: 'Negotiation',
    value: 'negotiation',
    description: 'Maximize your offer with guidance from a professional negotiator.',
  },
  communication: {
    name: 'Communication Coaching',
    AirtableService: 'Communication Skills',
    value: 'communication',
    description: 'Become a more effective speaker during interviews, meetings, 1:1s, and more.',
  },
  presentation: {
    name: 'Mock Presentation',
    AirtableService: 'Communication Skills',
    value: 'presentation',
    description: 'Practice delivering your presentation and receive actionable feedback.',
  },
};

const SessionStatus = {
  BOOKED: 'booked',
  CANCELED: 'canceled',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
  DELETED: 'deleted',
};

const ResumeReviewStatus = {
  UNPAID: 'unpaid',
  PAID: 'paid',
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  CANCELED: 'canceled',
  REFUNDED: 'refunded',
};

const SessionStatusDetail = {
  COACH_NO_SHOW: 'coach-no-show',
  STUDENT_NO_SHOW: 'student-no-show',
  COACH_CANCEL: 'coach-canceled',
  STUDENT_CANCEL: 'student-canceled',
  COACH_LATE_CANCEL: 'coach-canceled-late',
  STUDENT_LATE_CANCEL: 'student-canceled-late',
  HIDE_RATING: 'hide-rating',
};

const TranscriptStatus = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETE: 'complete',
  UNAVAILABLE: 'unavailable',
};

const CoachingRoomState = {
  PENDING: 'pending',
  LIVE: 'live',
  ENDED: 'ended',
  CANCELED: 'canceled',
};

// Displayed in the coach list and can be booked
const CoachAvailableStatuses = [
  'Active',
];

// Displayed in the coach list to admin users and can be booked by admin users
const CoachAvailableStatusesAdmin = [
  'Active',
  'Test',
];

// Not displayed in the coach list and can not be booked, but their profile pages still exist
const CoachAwayStatuses = [
  'Away',
  'Suspended',
  'Calendly error',
];

// Coach slugs doing PWAC
const PwacCoachSlugs = [
  'Krish',
  'Rolly-Seth',
  'Kevin-Armstrong',
  'Suman-Bukka',
  'Coachy-McTesterson', // dev test account
];

// Sessions booked before this cutoff were booked expecting Zoom and must stay
// on Zoom, even for PWAC coaches. Tuesday 2026-09-22, 9AM PT (PDT = UTC-7).
const PwacStartDate = '2026-09-22T16:00:00Z';

const isPwacSession = (coachSlug, sessionCreatedAt) => PwacCoachSlugs.includes(coachSlug)
  && moment(sessionCreatedAt).isAfter(PwacStartDate);

// Courses/tracks cross-promoted on coaching pages, keyed by skill tag slug;
// values must be public catalog slugs
const SkillCourseMap = {
  ai: 'gen-ai-interviews',
  'ai-agents': 'mastering-agentic-ai',
  'ai-evals': 'mastering-agentic-ai',
  'behavioral-interviews': 'behavioral',
  cybersecurity: 'security-engineer',
  dsa: 'swe-practice',
  fde: 'forward-deployed-engineering',
  genai: 'gen-ai-interviews',
  llms: 'gen-ai-interviews',
  'marketing-skill': 'pmm',
  mcp: 'mastering-agentic-ai',
  ml: 'ml-engineer',
  negotiation: 'tech-salary-offer-negotiation',
  'product-design-skill': 'product-designer-interview',
  'product-strategy-skill': 'product-strategy',
  'sql-skill': 'sql-interviews',
  'system-design-skill': 'system-design-interviews',
  'user-research': 'conduct-uer',
};

// Copy overrides for skill pages where the default interview-coaching framing doesn't fit
const SkillPageCopy = {
  negotiation: {
    title: 'Salary Negotiation Coaching',
    subtitle: 'Maximize your job offer with 1:1 help from expert tech negotiators',
    description: 'Maximize your job offer with 1:1 salary negotiation coaching. Learn proven tactics for negotiating salary and equity from expert tech negotiators.',
    promoHeading: 'Negotiate your offer like a pro',
    promoSubheading: 'Learn proven negotiation tactics with our self-paced course, then book an expert negotiator to maximize your offer.',
  },
};

// Same, keyed by industry tag slug (/coaching/{industry}).
const IndustryCourseMap = {
  'ai-industry': 'gen-ai-interviews',
  fintech: 'break-into-fintech',
};

// Same, keyed by role tag slug (/coaching/{role}).
const RoleCourseMap = {
  'ai-engineer': 'gen-ai-interviews',
  bizops: 'bizops',
  'data-analyst': 'data-analytics',
  'data-engineer': 'data-engineering',
  'data-science': 'data-science',
  em: 'engineering-management',
  'forward-deployed-engineer': 'forward-deployed-engineering',
  'investment-banking': 'investment-banking',
  'ml-engineer': 'ml-engineer',
  pm: 'pm',
  pmm: 'pmm',
  'product-designer': 'product-designer-interview',
  'solutions-architect': 'solution-architect-interview',
  swe: 'software-engineering',
  'system-design': 'system-design-interviews',
  tpm: 'tpm',
};

module.exports = {
  SessionTypes,
  SessionStatus,
  ResumeReviewStatus,
  SessionStatusDetail,
  TranscriptStatus,
  CoachingRoomState,
  CoachAvailableStatusesAdmin,
  CoachAvailableStatuses,
  CoachAwayStatuses,
  PwacCoachSlugs,
  PwacStartDate,
  isPwacSession,
  SkillCourseMap,
  SkillPageCopy,
  RoleCourseMap,
  IndustryCourseMap,
};
